import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CollectionNameDialogComponent } from './collection-name-dialog.component';

@NgModule({
  declarations: [CollectionNameDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [CollectionNameDialogComponent],
  entryComponents: [CollectionNameDialogComponent],
})
export class CollectionNameDialogModule {}
